import React, { useState } from "react";
import { Container, Modal, Button } from "react-bootstrap";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import Logo from "../../assets/checkinimg/img.png";
import "./CheckInLanding.css";

const Footer = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <footer className="footer-section">
                <Container>
                    <div className="footer-wrappers">
                        <div className="footer-logo">
                            <img src={Logo} alt="Logo" />
                        </div>

                        <p className="footer-copy">
                            © {new Date().getFullYear()}{" "}
                            <span className="highlight-brand">safeCircl</span>. All rights
                            reserved.
                        </p>

                        <div className="store-buttons">
                            <button className="store-btn" onClick={() => setShowModal(true)}>
                                <FaApple />
                                <span>App Store</span>
                            </button>

                            <button className="store-btn" onClick={() => setShowModal(true)}>
                                <FaGooglePlay />
                                <span>Google Play</span>
                            </button>
                        </div>

                        <nav className="footer-nav">
                            <a href="#">Privacy</a>
                            <a href="#">Terms</a>
                            <a href="#">Contact</a>
                        </nav>
                    </div>
                </Container>
            </footer>

            <Modal
                centered
                show={showModal}
                onHide={() => setShowModal(false)}
                className="coming-soon-modal"
            >
                <Modal.Body className="coming-soon-body">
                    <div className="coming-soon-icon">🚀</div>
                    <h3>Coming Soon</h3>
                    <p>
                        Our mobile application is currently under development and will be
                        available soon on App Store and Google Play.
                    </p>
                    <Button
                        className="coming-soon-btn"
                        onClick={() => setShowModal(false)}
                    >
                        Got It
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Footer;
